





















export default {
    name: "CmBack",

    props: [
        "sectionTitle",
        "contentName",
        "to",
        "action"
    ]
}
